export type CookieConsentChoice = 'all' | 'essential';

export interface CookieConsentRecord {
  choice: CookieConsentChoice;
  decidedAt: string;
}

const STORAGE_KEY = 'caremo_cookie_consent';

export function getCookieConsent(): CookieConsentRecord | null {
  if (typeof localStorage === 'undefined') return null;

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as CookieConsentRecord;
    if (parsed?.choice !== 'all' && parsed?.choice !== 'essential') return null;

    return parsed;
  } catch {
    return null;
  }
}

export function hasCookieConsentDecision(): boolean {
  return getCookieConsent() !== null;
}

export function saveCookieConsent(choice: CookieConsentChoice): void {
  const record: CookieConsentRecord = {
    choice,
    decidedAt: new Date().toISOString(),
  };

  localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
}

export function acceptsAnalyticsCookies(): boolean {
  return getCookieConsent()?.choice === 'all';
}
